@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<button
  type="button"
  ca-action-button
  color="primary"
  [style.visibility]="loading ? 'hidden' : 'visible'"
  matRipple
  (click)="pickFile($event)"
  >
  <mat-icon matListIcon>{{ iconName || "upload" }}</mat-icon>
  {{ label || "Upload a File" }}
</button>
<input
  [accept]="accept"
  type="file"
  style="display: none"
  [multiple]="multiple"
  #fileInput
  (change)="fileChange($event)"
  />
